import InputWrapper from "../../../../../components/Input/InputWrapper";
import classNames from "classnames";

const String = ({ settings = {} }) => {
    return (
        <InputWrapper>
            <span className={classNames({"required": settings.required})}>{settings.title}</span>
            <div/>
            {settings.description && <p>{settings.description}</p>}
        </InputWrapper>
    )
};

export default String;